import { classNames as joinClassNames } from "primereact/utils";

import styles from "./hub-table.module.scss";
import { HubTableState } from "./parts/view-state";
import { HubTableTable } from "./parts/view-table";
import type { HubTableViewProps } from "./types-hub-table";

/** Raiz: a moldura, com a tabela, as barras de rolagem e o paginador, ou com o estado da lista. */
export function HubTableView({
  view,
  className,
  style,
  testId,
  rest,
  classNames,
  size,
  tableId,
  isLoading,
}: HubTableViewProps) {
  return (
    <div
      className={joinClassNames(styles.root, className)}
      style={style}
      data-view={view}
      data-size={size}
      data-hubtable-id={tableId}
      aria-busy={isLoading}
      data-testid={testId}
      {...rest}
    >
      <div className={styles.column}>
        <div
          className={joinClassNames(
            styles.card,
            view === "table" ? styles.cardTable : undefined,
            classNames.card,
          )}
        >
          {view === "table" ? <HubTableTable /> : <HubTableState />}
        </div>
      </div>
    </div>
  );
}
